import {
  AfterViewInit,
  Component,
  DestroyRef,
  ElementRef,
  ViewChild,
  inject,
} from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-juris-sidekick-sso-layout',
  imports: [RouterOutlet],
  template: `
    <div class="tw-h-full tw-flex tw-flex-col">
      <header
        #headerEl
        class="sso-header tw-w-full tw-flex tw-flex-wrap tw-justify-center tw-bg-[var(--sed-grey-20-color)]"
        role="banner"
      >
        <div class="tw-max-w-[1300px] tw-flex-col tw-w-full tw-grow">
          <div class="tw-flex tw-p-2 sm:tw-p-6 tw-items-center tw-justify-start">
            <img
              src="assets/images/omni-logo.webp"
              class="logo tw-pr-4"
              alt="Sedgwick Logo"
            />
          </div>
        </div>
      </header>

      <div
        class="tw-w-full tw-flex tw-flex-col tw-items-center tw-grow tw-min-h-[80%] tw-bg-[var(--sed-grey-20-color)]"
        style="padding-top: var(--header-height, 0px);"
      >
        <div class="tw-max-w-[1300px] tw-w-full tw-grow tw-px-4 tw-pt-2">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  `,
  styles: `
    .sso-header {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      z-index: 1000;
      background-color: var(--sed-grey-20-color);
    }

    .logo {
      height: 38px;
      width: auto;
      max-width: 100%;
    }

    @media (max-width: 768px) {
      .logo {
        height: auto;
        max-height: 38px;
        max-width: 100%;
        padding-right: 0rem !important;
      }
    }
  `,
})
export class JurisSidekickSsoLayoutComponent implements AfterViewInit {
  private destroyRef = inject(DestroyRef);
  private headerObserver: ResizeObserver | null = null;

  @ViewChild('headerEl', { static: true })
  headerEl: ElementRef<HTMLElement>;

  ngAfterViewInit(): void {
    const host = this.headerEl.nativeElement;
    this.headerObserver = new ResizeObserver(() => {
      document.documentElement.style.setProperty(
        '--header-height',
        `${host.offsetHeight}px`,
      );
    });
    this.headerObserver.observe(host);
    this.destroyRef.onDestroy(() => this.headerObserver?.disconnect());
  }
}
